var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:[
               `${_vm.$appPrefix}-model-selection-module-button`, 
               `${_vm.$appPrefix}-model-selection-module-button--${_vm.theme}`
             ]},[_c('a',{on:{"click":_vm.onButtonClick}},[_c('MgsIcon',{attrs:{"name":_vm.icon,"file":_vm.file}}),_c('span',[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }